// Per-business-unit metrics for the Cross-BU Comparison table.
//
// GET /rest/api/v1/comparison/summary returns every BU on the account in one call:
//   { mid, midName, enterpriseName, enterpriseId, instanceId, mids: [
//       { mid, name,
//         dataExtensions: { total, sendable, shared },
//         automations:    { total, erroring },
//         journeys:       { total, active },
//         criticalPiiDataExtensions, activeSubscribers, hardBounced } ] }
//
// The `mid` query param (added by axiosInterceptor.js for a non-default BU) only
// sets the mid/midName echoed at the root — the mids[] rows are the whole account
// either way, which is what this table needs.

import axios from 'axios';

const SUMMARY_ENDPOINT = '/rest/api/v1/comparison/summary';

// Missing values are left undefined rather than coerced to 0: the table renders
// those as “—”, keeping "not reported" visibly different from a real zero.
function num(value) {
    return typeof value === 'number' ? value : undefined;
}

// Keyed by MID (as a string) to match the ids the header switcher builds from
// /business-units/mids.
export function normalizeBuSummary(payload) {
    const rows = Array.isArray(payload && payload.mids) ? payload.mids : [];
    const byMid = {};

    rows.forEach(row => {
        if (!row || row.mid == null) return;
        const des      = row.dataExtensions || {};
        const autos    = row.automations    || {};
        const journeys = row.journeys       || {};

        byMid[String(row.mid)] = {
            des:            num(des.total),
            sendable:       num(des.sendable),
            sharedDes:      num(des.shared),
            automations:    num(autos.total),
            autoError:      num(autos.erroring),
            journeys:       num(journeys.total),
            journeysActive: num(journeys.active),
            criticalPii:    num(row.criticalPiiDataExtensions),
            subscribers:    num(row.activeSubscribers),
            hardBounce:     num(row.hardBounced),
        };
    });

    return byMid;
}

export async function fetchBuSummary() {
    const { data } = await axios.get(SUMMARY_ENDPOINT);
    return normalizeBuSummary(data);
}
